<template>
  <div class="modal d-flex justify-content-center fade show mt-5 text-center loading-modal" tabindex="-1" role="dialog"
    aria-labelledby="loadingModalTitle" style="display: block;" aria-modal="true" data-focus-mouse="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content rounded shadow">
        <div class="modal-body">
          <p><b>{{ message || 'Caricamento in corso...' }}</b></p>
          <div class="spinner-grow text-primary mb-3" role="status">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingModal",
  props: {
    message: {
      type: String,
      default: 'Caricamento in corso...'
    }
  }
}
</script>

<style scoped>
.loading-modal {
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
